import {createSvgIcon} from '../create-svg-icon';

export const KeyboardArrowRightIcon = createSvgIcon(
  <path d="M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z" />
, 'KeyboardArrowRightOutlined');
